import { Route, Switch } from 'react-router-dom'
import { NotificationContainer } from 'react-notifications'
import routes from './routes'
import './App.scss'
function App() {
  return (
    <>
      <Switch>
        {routes.map((route) => {
          return <Route path={route.path} exact component={route.component} />
        })}
      </Switch>
      <NotificationContainer />
    </>
  )
}
export default App
